import { createApi } from "@reduxjs/toolkit/query/react";
import { GenericResponse, PaginatedObject } from "@/redux/models";
import { IEmpresa } from "@/redux/models/empresaTypes";
import customFetchBase from "./customFetchBase";


export const empresaApi = createApi({
  reducerPath: "empresaApi",
  baseQuery: customFetchBase,
  tagTypes: ["User"],
  endpoints: (builder) => ({
    crearEmpresa: builder.mutation<GenericResponse, any>({
      query(empresa) {
        return {
          url: `empresa`,
          method: "POST",
          body: empresa,
        };
      },
    }),
    obtenerEmpresas: builder.query<PaginatedObject<IEmpresa>, { desde?: number, hasta?: number } | void>({
      query(args: any) {
        return {
          url: `empresa/paginated`,
          method: "GET",
          params: {
            desde: args?.desde | 1,
            hasta: args?.hasta | 9999
          },
        };
      },
    }),
    obtenerEmpresa: builder.query<IEmpresa, number>({
      query(id) {
        return {
          url: `empresa/${id}`,
          method: "GET",
        };
      },
    }),
    editarEmpresa: builder.mutation<GenericResponse, Partial<IEmpresa>>({
      query(empresa) {
        return {
          url: `empresa`,
          method: "PUT",
          body: empresa,
        };
      },

    }),
  }),
});

export const { useCrearEmpresaMutation, useObtenerEmpresasQuery, useObtenerEmpresaQuery, useEditarEmpresaMutation } = empresaApi

export const useObtenerEmpresaLazyQuery = empresaApi.endpoints.obtenerEmpresa.useLazyQuery
export const useObtenerEmpresasLazyQuery = empresaApi.endpoints.obtenerEmpresas.useLazyQuery
